export const getFormFillingTipsStorageName = (userId: string): string => {
  return `closedFormFillingTips=${userId}`;
};
